import { colors } from './../../../config/styles'

export default {
	actionButton: {
		width: 'auto',
		fontSize: 16,
		paddingTop: 10,
		paddingBottom: 10,
	},
	linkWrapper: {
		color: colors.darkGray,
		border: `1px solid ${colors.lightGray}`,
		backgroundColor: colors.white,
		borderRadius: 5,

		transition: 'color 0.2s ease-in, background-color 0.2s ease-in, border 0.2s ease-in',

		':active': {
			color: colors.white,
			backgroundColor: colors.primary,
			border: `1px solid ${colors.primary}`,
		},
		':hover': {
			color: colors.white,
			backgroundColor: colors.primary,
			border: `1px solid ${colors.primary}`,
		},
	},
	link: {
		position: 'relative',
		width: '100%',
		display: 'block',
		textAlign: 'center',
		fontSize: 14,
		padding: 5,
	},
}
